module.exports = __webpack_public_path__ + "static/img/exam-type06.c550aee8.png";